import {
    CelebritiesVids_Data,
    //----------------------------------------Drop_DownsDataArrays-----------------------------------
    TaskData_Array,
    Contact_Data,
    Astro_Data,
    InquiryAction_Data,
    BankDetails_Data,
    SET_ASTRO_ID,
    InquiryAction_User,
    BankDetailsSingle_Data,
    AstrologerSingle_Data,
    QualificationDrp_Data,
    DregeeDiplomaDrp_Data,
    Horo_Data,
    HoroScopeName_Data,
    HoroScopeSingle_Data,
    SliderSingle_Data,
    Slider_Data,
    Wallet_Data,
    WalletSingle_Data,
    SkillsList_Data,
    SkillsListSingle_Data,
    LanguagesListSingle_Data,
    LanguagesList_Data,
    BlogCategory_Data,
    BlogCategorySingle_Data,
    DregeeDiploma_Data,
    DregeeDiplomaSingle_Data,
    Skills_Data,
    Languages_Data,
    Blog_Data,
    BlogSingle_Data,
    AstrologersCategory_Data,
    AstrologersCategorySingle_Data,
    AstroCategory_Data,
    BlogCategoryDrp_Data,
    SET_Blog_ID,
    PrivacyPolicy_Data,
    PrivacyPolicySingle_Data,
    PrivacyPolicyDrop_Data,
    CategoryNotification_Data,
    CategoryNotification_Single_Data,
    DataNotification_Data,
    SET_DROPDOWN_DATA,
    PushCategory_Single_Data,
    Pooja_Data,
    Pooja_Single_Data,
    Puja_Get_Data_Puja,
    PujaFor_GetDropDownData_PujaFor,
    Puja_GetSinglaData_Puja,
    SET__Puja_ID,
    SET__GemstoneOrderID,
    Gemstone_Category_data,
    GemstoneCategory_Singledata,
    Gemstone_GetData_GemData,
    GemstoneCategory_GetDropDawnData,
    Gemstone_Singledata,
    SET__Gemstone_ID,
    Gemstone_User,
    Gemstone_Cart_List,
    SinglaData_GemstoneOrder,
    Call_History,
    SET_DROPDOWN_ASTRO,
    CAll_CHART_DATA,
    Home_Page_Count,
    Chat_Acc_Day,
    Astro_Filter,
    User_Filter,
    Expense_Category,
    Single_Expense_Category,
    Insert_ExpenseCategory,
    Income_Category,
    SinglaData_IncomeCategory,
    Ticket_Category,
    SinglaData_Ticket_Category,
    Chat_Filter,
    Online_Puja_Filter,
    Gemstone_Filter,
    Call_Filter,
    User_Status,
    Total_Astrologer,
    Chat_Chart,
    Gemstone_Revenue,
    Pooja_Revenue,
    Call_Revenue,
    User_list,
    User_Insert,
    GetData_Users,
    SET_ADMIN_ID,
    AdminSingle_Data,
    Update_ExpenseCategory,
    Delete_ExpenseCategory,
    Expense_Details,
    Single_Expense_Details,
    Insert_Expense_Details,
    Update_Expense_Details,
    Delete_Expense_Details,
    GetDropDownData_ExpenseCategory,
    GetData_Muhurat,
    GetSinglaData_Muhurat,
    GetDropDwonData_Muhurat,
    GetData_MainMuhurat,
    GetSinglaData_MainMuhurat,
    GetData_TransactionCategory,
    GetSingleData_TransactionCategory,
    GetDropDownData_TransactionCategory,
    GetSinglaData_VratUpvaas,
    GetData_VratUpvaas,
    GetDropDwonData_MainVratUpvaas,
    GetData_MainVratUpvaas,
    GetSinglaData_MainVratUpvaas,
    GetData_CompanyTransaction,
    GetSingleData_CompanyTransaction,
    GetData_PaymentHistory,
    GetData_UserWalletTransaction,
    GetData_AstroWalletTransaction,
    Chat_Message,
    GetData_headerCompanyTransaction,
    GetsinglaData_Company,
    GetData_Company,
    GetData_Paymentbutnotbuy,
    GetData_PaymentchangeRequest,
    GetData_AstrologerGallery,
    GetSinglaData_AstrologerGallery,
    GetData_Feedback,
    GetSingleData_Feedback,
    GetData_UserNotUsed,
    GetSinglaData_PaymentchangeRequest,
    GetData_Festival,
    GetSinglaData_Festival,
    GetData_NotificationRule,
    GetSinglaData_NotificationRule,
    CategoryRedirect,
    CategoryRedirectsingle,
    CategoryCondition,
    AuthorName,
    AuthorNameSingle_Data,
    Categorys_Data,
    GetData_PackageRoles,
    GetSinglaData_PackageRoles,
    GetData_Expense,
    GetSinglaData_Expense,
    GetData_ChatAnalysisReport,
    GetData_WalletPlanName,
    GetsinglaData_WalletPlanName,
    SinglaData_User,
    GetData_AstroSallaryTransaction,

} from "../Action_Types"

const initialState = {
    // All use  
    TaskData: [], CelebritiesData: [], ContactData: [], AstroData: [], UserData: [],SingleUserData:[], InquiryActionData: [], InquiryUserData: [], SliderData: [], SliderSingleData: [], WalletData: [], WalletSingleData: [],



    //------------------HoroScopeName----------------------------
    HoroData: [], HoroScopeNameData: [], HoroScopeSingleData: [],

    //------------------AdminData----------------------------
    AdminID: [], AdminSingleData: [],

    //------------------AstrologerDetailsData-------------
    BankDetailsData: [], BankDetailsSingleData: [], selectedAstroId: null, AstrologerSingleData: [], DregeeDiplomaDrpData: [], QualificationDrpData: [],

    //---------------------------skillListData----------------------
    SkillsListData: [], SkillsListSingleData: [], LanguagesListData: [], LanguagesListSingleData: [], BlogCategoryData: [], BlogCategorySingleData: [],
    DregeeDiplomaData: [], DregeeDiplomaSingleData: [], SkillsData: [],CategoryData:[], LanguagesData: [], AstrologersCategoryData: [], AstrologersCategorySingleData: [],

    // blogs
    BlogData: [], BlogSingleData: [], BlogCategoryDrpData: [], BlogID: null, PujaID: '',

    //-----------------------------------------------PrivacyPolicy-------------------------------
    PrivacyPolicyData: [], PrivacyPolicySingleData: [], PrivacyPolicyDropData: [],

    //-----------------------------------------------Muhurat-------------------------------------

    MuhuratData: [], MuhuratSingleData: [], MuhuratDrpData: [], MainMuhuratData: [], MainMuhuratSingleData: [],

    //-----------------------------------------------PrivacyPolicy-------------------------------
    CategoryNotificationData: [], CategoryNotificationSingleData: [], DataNotificationData: [], dropdownData: [], PushCategorySingleData: [],

    //-----------------------------------------------Online Pooja-------------------------------
    PoojaData: [], PoojaSingleData: [], PujaGetDataPuja: [], PujaForGetDropDownDataPujaFor: [], PujaGetSinglaDataPuja: [], GemstoneFilter: [], CallFilter: [],


    //-----------------------------------------------Gemstone-------------------------------
    GemstoneCategorydata: [], GemstoneCategorySingledata: [], GemstoneCategoryGetDropDawnData: [], GemstoneSingledata: [], GemstoneGetDataGemData: [], GemstoneUser: [], GemstoneCartList: [], SinglaDataGemstoneOrder: [],



    //-----------------------------------------------CallHistory-------------------------------
    CallHistory: [], DROPDOWNASTRO: [],

    //-----------------------------------------------charts-------------------------------
    calldata: [], UserStatus: [], TotalAstrologer: [], TotalChart: [], GemstoneRevenues: [], PoojaRevenues: [], CallRevenues: [],
    //-----------------------------------------------Count-------------------------------
    HomePageCount: [], ChatAccDay: [],

    //-----------------------------------------------FilterData-------------------------------
    AstroFilter: [], UserFilter: [], ChatFilter: [], ONlinePujaFilter: [],

    //-----------------------------------------------IncomeCategory-------------------------------
    IncomeCategory: [], SinglaDataIncomeCategory: [], TicketCategory: [], SinglaDataTicketCategory: [],

    //-----------------------------------------ExpenseCaterogy-----------------------------------
    ExpenseCategory: [], SingleExpenseCategory: [], InsertExpenseCategory: [], UpdateExpenseCategory: [], DeleteExpenseCategory: [],

    //-----------------------------------------ExpenseDetails-----------------------------------
    ExpenseDetails: [], SingleExpenseDetails: [], InsertExpenseDetails: [], UpdateExpenseDetails: [], DeleteExpenseDetails: [], GetDropdownCategory: [],

    //-----------------------admin user----------------------------------------
    UserInsert: [], GetDataUsers: [],
    //-----------------------------------------Transaction----------------------------------------
    TransactionCategory: [], TransactionSingleCategory: [], TransactionDropCategory: [], CompanyTransactionSingle: [], CompanyTransaction: [], HeaderCompanyTransaction: [], Addcompanydata: [], newcompdata: [],

    PaymentHistory: [], UserWalletTransaction: [], AstroWalletTransaction: [],AstroSallaryTransaction:[], GetPaymentButNotBuy: [],GetDataPackageRoles:[],GetSinglaDataPackageRoles:[],


    //-----------------------VratUpvaas--------------------------------
    VratUpvaasData: [], VratUpvaasSingleData: [], VratUpvaasDrpData: [], MainVratUpvaasData: [], MainVratUpvaasSingleData: [],


    GetChatMessagehistory: [], GetPaymentChangeRequest: [], GetAstrologerData: [], GetSingleAstroGallery: [], GetReviewData: [], GetSingleReviewData: [], GetUserNotUserData: [], GetSingleNotUserData: [],

    GetFestivals: [],GetSingleFestival:[],GetNotificationrule:[],GetSingleNotificationRule:[],CategoryRedirectData:[],CategoryRedirectSingleData:[],CategoryConditionData:[],Authordata:[],AuthorSingleData:[],
    GetDataExpeses:[],GetSinglaDataExpeses:[],GetDataChatAnalyses:[],GetWalletPackageName:[],GetSingleWalletPackageName:[],



}

const CustomerFeedBackReducer = (state = initialState, action) => {
    switch (action.type) {
        case TaskData_Array:
            return {
                ...state,
                TaskData: action.payload
            }

            
        case CelebritiesVids_Data:
            return {
                ...state,
                CelebritiesData: action.payload
            }
        case Contact_Data:
            return {
                ...state,
                ContactData: action.payload
            }
        case Astro_Data:
            return {
                ...state,
                AstroData: action.payload
            }

        case User_list:
            return {
                ...state,
                UserData: action.payload
            }

             case SinglaData_User:
            return {
                ...state,
                SingleUserData: action.payload
            }


        case InquiryAction_Data:
            return {
                ...state,
                InquiryActionData: action.payload
            }
        case InquiryAction_User:
            return {
                ...state,
                InquiryUserData: action.payload
            }
        case Slider_Data:
            return {
                ...state,
                SliderData: action.payload
            }
        case SliderSingle_Data:
            return {
                ...state,
                SliderSingleData: action.payload
            }



        //--------------------------------------HoroScopeName----------------------------------------------
        case Horo_Data:
            return {
                ...state,
                HoroData: action.payload
            }
        case HoroScopeName_Data:
            return {
                ...state,
                HoroScopeNameData: action.payload,
            };
        case HoroScopeSingle_Data:
            return {
                ...state,
                HoroScopeSingleData: action.payload,
            };

        //--------------------------------------WalletData----------------------------------------------
        case Wallet_Data:
            return {
                ...state,
                WalletData: action.payload
            }

        case WalletSingle_Data:
            return {
                ...state,
                WalletSingleData: action.payload,
            };

        //---------------------------------------AdminData----------------------------------------------

        case SET_ADMIN_ID:
            return {
                ...state,
                AdminID: action.payload,
            };

        case AdminSingle_Data:
            return {
                ...state,
                AdminSingleData: action.payload,
            };


        //--------------------------------------BlogData----------------------------------------------
        case Blog_Data:
            return {
                ...state,
                BlogData: action.payload
            }
        case BlogSingle_Data:
            return {
                ...state,
                BlogSingleData: action.payload
            }


        case BlogCategoryDrp_Data:
            return {
                ...state,
                BlogCategoryDrpData: action.payload
            }




        // ----------------------------------AstrologerDetails_Data-----------------------
        case BankDetails_Data:
            return {
                ...state,
                BankDetailsData: action.payload
            }
        case BankDetailsSingle_Data:
            return {
                ...state,
                BankDetailsSingleData: action.payload
            }
        case SET_ASTRO_ID:
            return {
                ...state,
                selectedAstroId: action.payload,
            };

        case SET_Blog_ID:
            return {
                ...state,
                BlogID: action.payload,
            };

        case AstrologerSingle_Data:
            return {
                ...state,
                AstrologerSingleData: action.payload,
            };
        case QualificationDrp_Data:
            return {
                ...state,
                QualificationDrpData: action.payload,
            };

        case DregeeDiplomaDrp_Data:
            return {
                ...state,
                DregeeDiplomaDrpData: action.payload,
            };


        //------------------------------ListTable_Data--------------------------------
        case SkillsList_Data:
            return {
                ...state,
                SkillsListData: action.payload,
            };

        case SkillsListSingle_Data:
            return {
                ...state,
                SkillsListSingleData: action.payload,
            };

        case LanguagesList_Data:
            return {
                ...state,
                LanguagesListData: action.payload,
            };
        case LanguagesListSingle_Data:
            return {
                ...state,
                LanguagesListSingleData: action.payload,
            };

 case AuthorName:
            return {
                ...state,
                Authordata: action.payload,
            };
        case AuthorNameSingle_Data:
            return {
                ...state,
                AuthorSingleData: action.payload,
            };


        case BlogCategory_Data:
            return {
                ...state,
                BlogCategoryData: action.payload,
            };
        case BlogCategorySingle_Data:
            return {
                ...state,
                BlogCategorySingleData: action.payload,
            };

        case DregeeDiploma_Data:
            return {
                ...state,
                DregeeDiplomaData: action.payload,
            };
        case DregeeDiplomaSingle_Data:
            return {
                ...state,
                DregeeDiplomaSingleData: action.payload,
            };

        case Skills_Data:
            return {
                ...state,
                SkillsData: action.payload,
            };

 case Categorys_Data:
            return {
                ...state,
                CategoryData: action.payload,
            };

        case Languages_Data:
            return {
                ...state,
                LanguagesData: action.payload,
            };


        case AstrologersCategory_Data:
            return {
                ...state,
                AstrologersCategoryData: action.payload,
            };

        case AstrologersCategorySingle_Data:
            return {
                ...state,
                AstrologersCategorySingleData: action.payload,
            };

        //-------------------------------------------PrivacyPolicy------------------------------
        case PrivacyPolicy_Data:
            return {
                ...state,
                PrivacyPolicyData: action.payload,
            };
        case PrivacyPolicySingle_Data:
            return {
                ...state,
                PrivacyPolicySingleData: action.payload,
            };
        case PrivacyPolicyDrop_Data:
            return {
                ...state,
                PrivacyPolicyDrpData: action.payload,
            };

        //---------------------Mururat--------------------------------------------------
        case GetData_Muhurat:
            return {
                ...state,
                MuhuratData: action.payload,
            };
        case GetSinglaData_Muhurat:
            return {
                ...state,
                MuhuratSingleData: action.payload,
            };

        case GetDropDwonData_Muhurat:
            return {
                ...state,
                MuhuratDrpData: action.payload,
            };

        case GetData_MainMuhurat:
            return {
                ...state,
                MainMuhuratData: action.payload,
            };
        case GetSinglaData_MainMuhurat:
            return {
                ...state,
                MainMuhuratSingleData: action.payload,
            };





        //-------------------------------------VratUpvaas--------------------------------
        case GetData_VratUpvaas:
            return {
                ...state,
                VratUpvaasData: action.payload,
            };
        case GetSinglaData_VratUpvaas:
            return {
                ...state,
                VratUpvaasSingleData: action.payload,
            };

        case GetDropDwonData_MainVratUpvaas:
            return {
                ...state,
                VratUpvaasDrpData: action.payload,
            };

        case GetData_MainVratUpvaas:
            return {
                ...state,
                MainVratUpvaasData: action.payload,
            };
        case GetSinglaData_MainVratUpvaas:
            return {
                ...state,
                MainVratUpvaasSingleData: action.payload,
            };






        case CategoryNotification_Data:
            return {
                ...state,
                CategoryNotificationData: action.payload,
            };
        case CategoryNotification_Single_Data:
            return {
                ...state,

                CategoryNotificationSingleData: action.payload,
            };


              case CategoryRedirect:
            return {
                ...state,
                CategoryRedirectData: action.payload,
            };
             case CategoryCondition:
            return {
                ...state,
                CategoryConditionData: action.payload,
            };
        case CategoryRedirectsingle:
            return {
                ...state,

                CategoryRedirectSingleData: action.payload,
            };





        case DataNotification_Data:
            return {
                ...state,
                DataNotificationData: action.payload,
            };
        case SET_DROPDOWN_DATA:

            return {
                ...state,
                dropdownData: action.payload,
            };
        case SET_DROPDOWN_ASTRO:

            return {
                ...state,
                DROPDOWNASTRO: action.payload,
            };

        case PushCategory_Single_Data:
            return {
                ...state,
                PushCategorySingleData: action.payload,
            };
        case Pooja_Data:
            return {
                ...state,
                PoojaData: action.payload,
            }
        case Pooja_Single_Data:
            return {
                ...state,
                PoojaSingleData: action.payload,
            };
        case Puja_Get_Data_Puja:
            return {
                ...state,
                PujaGetDataPuja: action.payload,
            };
        case PujaFor_GetDropDownData_PujaFor:

            return {
                ...state,
                PujaForGetDropDownDataPujaFor: action.payload,
            };
        case Puja_GetSinglaData_Puja:

            return {
                ...state,
                PujaGetSinglaDataPuja: action.payload,
            };

        case SET__Puja_ID:
            return {
                ...state,
                PujaID: action.payload
            }
        case SET__GemstoneOrderID:
            return {
                ...state,
                GemstoneOrderID: action.payload
            }
        case SET__Gemstone_ID:
            return {
                ...state,
                GemstoneID: action.payload
            }
        case Gemstone_Category_data:
            return {
                ...state,
                GemstoneCategorydata: action.payload,
            }
        case GemstoneCategory_Singledata:
            return {
                ...state,
                GemstoneCategorySingledata: action.payload,
            }
        case Gemstone_GetData_GemData:
            return {
                ...state,
                GemstoneGetDataGemData: action.payload,
            }
        case GemstoneCategory_GetDropDawnData:
            return {
                ...state,
                GemstoneCategoryGetDropDawnData: action.payload,
            }
        case Gemstone_Singledata:

            return {
                ...state,
                GemstoneSingledata: action.payload,
            }
        case Gemstone_User:
            return {
                ...state,
                GemstoneUser: action.payload,
            }
        case Gemstone_Cart_List:
            return {
                ...state,
                GemstoneCartList: action.payload,
            }


        case SinglaData_GemstoneOrder:
            return {
                ...state,
                SinglaDataGemstoneOrder: action.payload,
            };

        case Call_History:
            return {
                ...state,
                CallHistory: action.payload,
            }
        case CAll_CHART_DATA:
            return {
                ...state,
                calldata: action.payload,
            }


        case Home_Page_Count:
            return {
                ...state,
                HomePageCount: action.payload,
            }

        case Chat_Acc_Day:
            return {
                ...state,
                ChatAccDay: action.payload,
            }
        //   -----------charts reducer--------------
        case User_Status:
            return {
                ...state,
                UserStatus: action.payload,
            }

        case Total_Astrologer:
            return {
                ...state,
                TotalAstrologer: action.payload,

            }

        case Chat_Chart:
            return {
                ...state,
                TotalChart: action.payload,

            }
        case Gemstone_Revenue:
            return {
                ...state,
                GemstoneRevenues: action.payload,

            }
        case Pooja_Revenue:
            return {
                ...state,
                PoojaRevenues: action.payload,

            }
        case Call_Revenue:
            return {
                ...state,
                CallRevenues: action.payload,

            }
        // -----------dashboard filter-----------

        case Astro_Filter:
            return {
                ...state,
                AstroFilter: action.payload,
            }

        case User_Filter:
            return {
                ...state,
                UserFilter: action.payload,
            }

        case Chat_Filter:
            return {
                ...state,
                ChatFilter: action.payload,
            }
        case Online_Puja_Filter:
            return {
                ...state,
                ONlinePujaFilter: action.payload,
            }

        case Gemstone_Filter:
            return {
                ...state,
                GemstoneFilter: action.payload,
            }

        case Call_Filter:
            return {
                ...state,
                CallFilter: action.payload,
            }



        case Expense_Category:
            return {
                ...state,
                ExpenseCategory: action.payload,
            }
        case Single_Expense_Category:
            return {
                ...state,
                SingleExpenseCategory: action.payload,
            }

        case Insert_ExpenseCategory:
            return {
                ...state,
                InsertExpenseCategory: action.payload,
            }

        case Update_ExpenseCategory:
            return {
                ...state,
                UpdateExpenseCategory: action.payload,
            }
        case Delete_ExpenseCategory:
            return {
                ...state,
                DeleteExpenseCategory: action.payload,
            }


        case Expense_Details:
            return {
                ...state,
                ExpenseDetails: action.payload,
            }
        case Single_Expense_Details:
            return {
                ...state,
                SingleExpenseDetails: action.payload,
            }
        case Insert_Expense_Details:
            return {
                ...state,
                InsertExpenseDetails: action.payload,
            }
        case Update_Expense_Details:
            return {
                ...state,
                UpdateExpenseDetails: action.payload,
            }
        case Delete_Expense_Details:
            return {
                ...state,
                DeleteExpenseDetails: action.payload
            }

        case GetDropDownData_ExpenseCategory:
            return {
                ...state,
                GetDropdownCategory: action.payload
            }


        case GetData_TransactionCategory:
            return {
                ...state,
                TransactionCategory: action.payload,
            }

        case GetsinglaData_Company:
            return {
                ...state,
                Addcompanydata: action.payload,
            }
        case GetData_Company:
            return {
                ...state,
                newcompdata: action.payload,
            }



        case GetDropDownData_TransactionCategory:
            return {
                ...state,
                TransactionDropCategory: action.payload
            }


        case GetData_CompanyTransaction:
            return {
                ...state,
                CompanyTransaction: action.payload,
            }
        case GetSingleData_CompanyTransaction:
            return {
                ...state,
                CompanyTransactionSingle: action.payload
            }
        case GetData_headerCompanyTransaction:
            return {
                ...state,
                HeaderCompanyTransaction: action.payload
            }

        case GetData_PaymentHistory:
            return {
                ...state,
                PaymentHistory: action.payload,
            }
        case GetData_UserWalletTransaction:
            return {
                ...state,
                UserWalletTransaction: action.payload,
            }

        case GetData_AstroWalletTransaction:
            return {
                ...state,
                AstroWalletTransaction: action.payload,
            }

             case GetData_AstroSallaryTransaction:
            return {
                ...state,
                AstroSallaryTransaction: action.payload,
            }






        case Income_Category:
            return {
                ...state,
                IncomeCategory: action.payload,
            }
        case SinglaData_IncomeCategory:
            return {
                ...state,
                SinglaDataIncomeCategory: action.payload,
            }
        case Ticket_Category:
            return {
                ...state,
                TicketCategory: action.payload,
            }
        case SinglaData_Ticket_Category:
            return {
                ...state,
                SinglaDataTicketCategory: action.payload,
            }

        case User_Insert:
            return {
                ...state,
                UserInsert: action.payload,
            }

        case GetData_Users:
            return {
                ...state,
                GetDataUsers: action.payload,
            }
        case Chat_Message:
            return {
                ...state,
                GetChatMessagehistory: action.payload,
            }
        case GetData_Paymentbutnotbuy:
            return {
                ...state,
                GetPaymentButNotBuy: action.payload,
            }
        case GetData_PaymentchangeRequest:
            return {
                ...state,
                GetPaymentChangeRequest: action.payload,
            }
        case GetData_AstrologerGallery:
            return {
                ...state,
                GetAstrologerData: action.payload,
            }
        case GetSinglaData_AstrologerGallery:
            return {
                ...state,
                GetSingleAstroGallery: action.payload,
            }
        case GetData_Feedback:
            return {
                ...state,
                GetReviewData: action.payload,
            }
        case GetSingleData_Feedback:
            return {
                ...state,
                GetSingleReviewData: action.payload,
            }
        case GetData_UserNotUsed:
            return {
                ...state,
                GetUserNotUserData: action.payload
            }
        case GetSinglaData_PaymentchangeRequest:
            return {
                ...state,
                GetSingleNotUserData: action.payload
            }
       
            case GetData_Festival:
            return {
                ...state,
                GetFestivals: action.payload
            }
         case GetSinglaData_Festival:
            return{
                ...state,
                GetSingleFestival:action.payload
            }


            case GetData_NotificationRule:
            return {
                ...state,
                GetNotificationrule: action.payload
            }
         case GetSinglaData_NotificationRule:
            return{
                ...state,
                GetSingleNotificationRule:action.payload
            }
            case GetData_PackageRoles:
                return{
                    ...state,
                    GetDataPackageRoles:action.payload
                }
                case GetSinglaData_PackageRoles:
                    return{
                        ...state,
                        GetSinglaDataPackageRoles:action.payload
                    }

                     case GetData_Expense:
                return{
                    ...state,
                    GetDataExpeses:action.payload
                }
                case GetSinglaData_Expense:
                    return{
                        ...state,
                        GetSinglaDataExpeses:action.payload
                    }
                    case GetData_ChatAnalysisReport:
                    return{
                        ...state,
                        GetDataChatAnalyses:action.payload
                    }

                     case GetData_WalletPlanName:
                    return{
                        ...state,
                        GetWalletPackageName:action.payload
                    }
                    case GetsinglaData_WalletPlanName:
                    return{
                        ...state,
                        GetSingleWalletPackageName:action.payload
                    }

        default: return state
    }
}

export default CustomerFeedBackReducer
